/* src/app/components/working-hours-modal/working-hours-modal.component.scss */
.opening-hours ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.opening-hours ul li {
  padding: 1px 0;
  font-family: AppFont;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.04em;
}
.opening-hours ul li:last-child {
  border-bottom: none;
}
/*# sourceMappingURL=working-hours-modal.component.css.map */
